import { Link, useLocation } from "react-router-dom";
import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import logo from "@/assets/logo.png";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "Services", path: "/services" },
  { label: "Gallery", path: "/gallery" },
  { label: "Calculator", path: "/calculator" },
  { label: "FAQ", path: "/faq" },
  { label: "Contact", path: "/contact" },
];

const SiteNavbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-secondary/95 backdrop-blur-md">
      <div className="container mx-auto flex items-center justify-between py-3 px-4">
        <Link to="/" className="flex items-center gap-3">
          <img src={logo} alt="ShashiSun Energy Logo" className="h-12 w-auto" width={72} height={48} />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors ${
                location.pathname === link.path
                  ? "text-primary"
                  : "text-secondary-foreground/70 hover:text-secondary-foreground"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a href="tel:9145863773" className="flex items-center gap-2">
            <Button variant="solar" size="sm">
              <Phone className="h-4 w-4" />
              Call Now
            </Button>
          </a>
        </nav>

        {/* Mobile toggle */}
        <button className="md:hidden text-secondary-foreground" onClick={() => setOpen(!open)}>
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="md:hidden bg-secondary border-t border-border/20 px-4 pb-4 animate-fade-in">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setOpen(false)}
              className={`block py-3 font-medium transition-colors ${
                location.pathname === link.path
                  ? "text-primary"
                  : "text-secondary-foreground/70"
              }`}
            >
              {link.label}
            </Link>
          ))}
          <a href="tel:9145863773">
            <Button variant="solar" className="w-full mt-2">
              <Phone className="h-4 w-4" /> Call Now
            </Button>
          </a>
        </div>
      )}
    </header>
  );
};

export default SiteNavbar;
